module.exports = __webpack_public_path__ + "img/pr-8.03806c12.png";